import type { Business, List, UserNotes } from '../dashboard/dashboardTypes';

enum ReportActionTypes {
	REPORT_ADD_REQUEST = 'report/REPORT_ADD_REQUEST',
	REPORT_ADD_SUCCESS = 'report/REPORT_ADD_SUCCESS',
	REPORT_ADD_FAILURE = 'report/REPORT_ADD_FAILURE',

	REPORT_GET_REPORTS_REQUEST = 'report/REPORT_GET_REPORTS_REQUEST',
	REPORT_GET_REPORTS_SUCCESS = 'report/REPORT_GET_REPORTS_SUCCESS',
	REPORT_GET_REPORTS_FAILURE = 'report/REPORT_GET_REPORTS_FAILURE',
	REPORT_GET_REPORTS_CLEAR_STATE = 'report/REPORT_GET_REPORTS_CLEAR_STATE'
}

enum ReportType {
	Export = 'EXPORT'
}

interface Report {
	type: string;
	businessIds: string[];
}

interface ReportBusiness extends Business {
	category: string;

	notes: UserNotes;

	re2score: number;
}

interface ReportCategoryResult {
	contacted: number;
}

interface ReportUserPeriod {
	startDate: Date;
	endDate: Date;
	userEmail: string | string[];
	listId?: string;
	method?: string;
	listName?: string;
	locationId?: string;
}

interface ReportEmails {
	total: number;
	opened: number;
}

interface ResultReport {
	[key: string]:
		| ReportCategoryResult
		| number
		| ResultReport[]
		| undefined
		| ReportBusiness[]
		| ReportEmails
		| List[];
	totalContacted: number;
	totalBusinessesExported: number;
	totalListsCreated: number;
	listBusinessesAmount?: number;
	emails?: ReportEmails;
	result?: ResultReport[];
	lists?: List[];
	contactedBusinesses: ReportBusiness[];
}

interface Feed {
	date: Date;
	activities: string[];
}

interface ReportAction {
	type: ReportActionTypes;
	payload?: Report | ResultReport | ReportUserPeriod;
	error?: Error;
}

const DAILY_AVERAGE_CONTACT = 4;

export {
	ReportActionTypes,
	ReportType,
	Report,
	ResultReport,
	ReportAction,
	ReportUserPeriod,
	ReportCategoryResult,
	ReportBusiness,
	Feed,
	DAILY_AVERAGE_CONTACT
};
